import React from "react";
import PrivateNativeDate from "../PrivateNativeDate";
function DateTimePicker({ ...props }) {
    return React.createElement(PrivateNativeDate, { type: "datetime-local", ...props });
}
export default DateTimePicker;
//# sourceMappingURL=DateTimePicker.js.map